import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';

function Header({ 
  showTeamSelector = false, 
  showDomainSelector = false, 
  showRegionSelector = false,
  selectedDomain,
  selectedRegion,
  domains,
  regions,
  onDomainChange,
  onRegionChange,
  onTeamChange,
  onLogout
}) {
  const { userProfile, availableTeams } = useAuth();

  return (
    <header className="dashboard-header">
      <h1>JurisAI</h1>
      <div className="user-info">
        {userProfile && (
          <>
            <span>{userProfile.name || userProfile.email}</span>
            
            {/* Team selector dropdown - only show if there are multiple teams */}
            {showTeamSelector && availableTeams.length > 1 && (
              <div className="team-selector">
                <select 
                  value={userProfile.teamId}
                  onChange={onTeamChange}
                  className="team-select"
                >
                  {availableTeams.map(team => (
                    <option key={team.teamId} value={team.teamId}>
                      {team.teamName}
                    </option>
                  ))}
                </select>
              </div>
            )}
            
            {/* Domain selector dropdown */}
            {showDomainSelector && domains && (
              <div className="team-selector">
                <select 
                  value={selectedDomain}
                  onChange={onDomainChange}
                  className="team-select"
                >
                  {domains.map(domain => (
                    <option key={domain} value={domain}>
                      {domain}
                    </option>
                  ))}
                </select>
              </div>
            )}
            
            {/* Region selector dropdown */}
            {showRegionSelector && regions && (
              <div className="team-selector">
                <select 
                  value={selectedRegion}
                  onChange={onRegionChange}
                  className="team-select"
                >
                  {regions.map(region => (
                    <option key={region} value={region}>
                      {region}
                    </option>
                  ))}
                </select>
              </div>
            )}
            
            <Link 
              to="/debug" 
              style={{
                marginLeft: '15px',
                padding: '4px 10px',
                textDecoration: 'none',
                color: '#666',
                fontSize: '12px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                background: '#f5f5f5'
              }}
            >
              Debug
            </Link>
            
            {onLogout && (
              <button onClick={onLogout} className="logout-button">Logout</button>
            )}
          </>
        )}
      </div>
    </header>
  );
}

export default Header;